export default __webpack_public_path__ + "static/media/flatiron_building.0332bc69.jpg";